<template>
  <div id="app">
    <v-app id="inspire">
      <v-content>
        <router-view></router-view>

        <!-- BarCode -->
        <barcode v-show="visLettore"></barcode>

        <!-- Plugins -->
        <toast></toast>
        <confirm></confirm>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import Barcode from "@/components/leggiBarcode";
import load from "@/LOAD.js";

export default {
  name: "App",
  components: {
    Barcode
  },

  methods: {
    async checkAppUpdate() {

      if (this.$functions.CordovaApp()) {

        // ---------- Controllo aggiornamento apk -----------

        try {
          var updateUrl = load.getUpdate();
          window.AppUpdate.checkAppUpdate(onSuccess, onFail, updateUrl, {
            skipPromptDialog: true,
            skipProgressDialog: true
          });
        } catch (ex) {
          console.log(ex);
        }
        function onFail() {
          //console.log("fail", JSON.stringify(arguments), arguments);
        }
        function onSuccess() {
          //console.log("success", JSON.stringify(arguments), arguments);
        }

      }
      else {

        // ---------- Controllo aggiornamento app web -----------

        try {
          let resUpdate = await this.$functions.checkUpdate(load.getUrl_Update());

          if (resUpdate) this.$toast.update("E' disponibile una nuova versione");
          // ---------
        } catch (error) {
          this.$toast.info(this.$i2kFunctions.getErrorMsg(error));
        }

      }
    }
  },

  mounted() {
    // verifico aggiornamenti apk
    this.checkAppUpdate();
  },

  computed: {
    getLink() {
      return this.$store.getters["app/getLink"];
    },

    getDialog() {
      return this.$store.getters["app/getDialog"];
    },

    visLettore() {
      if (this.getDialog == "evasione") return false;

      if (this.getLink == "/evasione" || this.getLink == "/ricevimento")
        return true;

      return false;
    }
  }
};
</script>

